module.exports = __webpack_public_path__ + "static/img/bg.9a8fe07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/statistic/bg.png
// module id = w5Cl
// module chunks = 2